import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminCreateTranslationMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminCreateTranslationMutationResultFragment, AdminCreateTranslationMutationParams } from '@docpace/admin-graphql'

const typedAdminCreateTranslationMutationDocument = AdminCreateTranslationMutationDocument as TypedDocumentNode<AdminCreateTranslationMutationResultFragment, Partial<AdminCreateTranslationMutationParams>>

export function useAdminCreateTranslationMutation(opts?: useMutation.Options<AdminCreateTranslationMutationResultFragment, Partial<AdminCreateTranslationMutationParams>>){
    return useMutation(typedAdminCreateTranslationMutationDocument, opts)
}
